import { TWPERMISSIONS } from 'dataSource/auth/types'

// Exact page paths
export const pageRoutes = {
  LOGIN: '/app/login',
  MAGIC_LOGIN: '/login?redirect=true',
  PROVIDER_SEARCH: '/app/providers',
  PRE_SEARCH_QUESTIONNAIRE: '/app/search-questionnaire',
  PROVIDER_PROFILE: '/app/providers/us',
  BOOKING: '/app/bookings',
  BOOKING_SUPPORT_EMAIL: '/app/bookings/support/email',
  BOOKING_SUPPORT_CONFIRM_CONSENT: '/app/bookings/support/patient-info',
  BOOKING_SUPPORT_PAYMENT: '/app/bookings/support/payment',
  BOOKING_USER_CONFIRM_CONSENT: '/app/bookings/user/patient-info',
  BOOKING_USER_PAYMENT: '/app/bookings/user/payment',
  DASHBOARD_USER_HOME: '/app/patient/dashboard/home',
  DASHBOARD_USER_SESSIONS: '/app/patient/dashboard/sessions',
  DASHBOARD_USER_SESSIONS_UPCOMING: '/app/patient/dashboard/sessions/upcoming',
  DASHBOARD_USER_SESSIONS_PAST: '/app/patient/dashboard/sessions/past',
  DASHBOARD_USER_BILLING: '/app/patient/dashboard/billing',
  DASHBOARD_USER_BILLING_SESSION: '/app/patient/dashboard/billing/session',
  DASHBOARD_USER_ACCOUNT: '/app/patient/dashboard/account',
  DASHBOARD_USER_ACCOUNT_SETTINGS: '/app/patient/dashboard/account/settings',
  DASHBOARD_USER_FIRESIDE: '/app/patient/dashboard/fireside',
  DASHBOARD_SUPPORT: '/app/support/dashboard',
  DASHBOARD_SUPPORT_USER: '/app/support/dashboard/user',
  DASHBOARD_SUPPORT_USER_SESSION: '/app/support/dashboard/user/session',
  DASHBOARD_SUPPORT_USER_ACCOUNT_NOT_FOUND:
    '/app/support/dashboard/useraccountnotfound',
  DASHBOARD_SUPPORT_USER_INSURANCE_VERIFICATION:
    '/app/support/dashboard/insurance-verification',
  VERIFY_SUCCESS: '/app/verify_success',
  VERIFY_USER_CONSENT: '/app/verify-user-consent',
  VERIFY_CARD: '/app/verify/consent',
  VERIFY_USER_PAYMENT: '/app/verify-user-payment',
  FIRST_TIME_USER: '/app/first-time-user',
  FIRST_TIME_AMD_USER: '/app/first-time-amd-user',
  PAGE_NOT_FOUND: '/app/404', // Page doesn't actual exists
  UNDER_MAINTENANCE: '/app/under-maintenance',
  B2B_VERIFICATION_SUCCESS: '/app/partners/verificationsuccess',
  LOGIN_EMAIL_SENT: '/login/email-sent',
  LOGIN_VERIFY_OTP: '/login/verify-otp',
  LOGIN_DASHBOARD: '/login/dashboard',
  B2B_PARTNER_DIRECTORY: '/app/partners',
  VERIFY_USER_IDENTITY: '/app/bookings/verify-user',
  THRIVECARE_CLINICIAN_HOME: '/care/clinician/home',
  AGENDA: '/agenda',
  AGENDA_DASHBOARD: '/agenda/dashboard',
  FORMSORT: '/app/formsort',
  REDALERT: '/app/support/dashboard/red-alert',
  SYNC_AUDIT: '/app/support/dashboard/red-alert/sync-audit',
  RED_ALERT_ADVANCED: '/red-alert',
  CARE_ADMIN: '/care/admin',
}

// Se-Friendly routes
export const seFriendlyPageRoutes = {
  SE_FRIENDLY: '/se-friendly/',
  SE_FRIENDLY_THERAPISTS_HUB: '/se-friendly/therapists',
  SE_FRIENDLY_PSYCHIATRISTS_HUB: '/se-friendly/psychiatrists',
}

// ThriveCare routes
export const thriveCarePageRoutes = {
  THRIVECARE_CLINICIAN_HOME: '/care/clinician/home',
  THRIVECARE_CLINICIAN_HOME_V1: '/care/v1',
  THRIVECARE_CLINICIAN_SCHEDULE: '/care/clinician/home/schedule',
  THRIVECARE_FAQ: '/care/faq',
  THRIVECARE_FACE_SHEET: '/care/clinician/client-info',
}

export const thriveCareV1PageRoutes = {
  THRIVECARE_V1_MBC_DASHBOARD: '/care/v1/mbc/dashboard',
  THRIVECARE_V1_CLIENT_LIST: '/care/v1/client-list',
  THRIVECARE_V1_MY_SCHEDULE: '/care/v1',
  THRIVECARE_V1_CLIENT_DETAIL: (encryptedLicenseKeyEhrId: string): string =>
    `/care/v1/client-info/${encryptedLicenseKeyEhrId}`,
  THRIVECARE_REFERRAL: '/care/v1/referral',
  THRIVECARE_CALENDAR: '/care/v1/calendar',
  THRIVECARE_REFERRAL_DONE: '/care/v1/referral/done',
  THRIVECARE_MAINTENANCE: '/care/maintenance',
}

// These are the routes that users will be sent to after login and if they
// try to access a page they didn't have access to
export const homePageRoutes = {
  [TWPERMISSIONS.CLINICIAN]: thriveCarePageRoutes.THRIVECARE_CLINICIAN_SCHEDULE,
  [TWPERMISSIONS.SUPPORT]: pageRoutes.DASHBOARD_SUPPORT,
  [TWPERMISSIONS.DEVOPS_ADMIN]: pageRoutes.DASHBOARD_SUPPORT,
  [TWPERMISSIONS.THIRD_PARTY_SUPPORT]: pageRoutes.PROVIDER_SEARCH,
  [TWPERMISSIONS.CLINICAL_ADMIN]: pageRoutes.LOGIN_DASHBOARD,
}
// Parent path which catches all its subpath
export const catchAllPageRoutes = {
  DASHBOARD_USER: '/app/patient/dashboard/[...page]',
  DASHBOARD_FIRESIDE: `${pageRoutes.DASHBOARD_USER_FIRESIDE}/[...coursedetail]`,
}

export const redAlertPageRoutes = {
  RED_ALERT: '/red-alert',
  AUDIT_SYNC: '/red-alert/audit-sync',
  ACCOUNT_LINKING: '/red-alert/account-linking',
  PATIENT_DETAILS: '/red-alert/patient/',
  APPOINTMENT_DETAILS: '/red-alert/appointment/',
  TICKETS: '/red-alert/tickets/',
  PERMISSION_CHECKER: '/red-alert/permissions-checker',
}

export const careAdminRoutes = {
  TASK_DETAILS_PAGE: (taskConfigId: string): string =>
    `${pageRoutes.CARE_ADMIN}/${taskConfigId}`,
  NEW_TASK_PAGE: `${pageRoutes.CARE_ADMIN}/new`,
  EDIT_TASK_PAGE: (taskConfigId: string): string =>
    `${pageRoutes.CARE_ADMIN}/${taskConfigId}/edit`,
}
